export default __webpack_public_path__ + "static/media/react-router.e50ddc4a.jpg";